import { isAllowed } from 'services/policy'

export default () => ({
  link(_$scope, $element, $attrs) {
    isAllowed($attrs.evaCheckAllowed) ? $element.show() : $element.hide();
  }
});
